import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const Ctx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [branches, setBranches] = useState([]);
  const [branch, setBranchState] = useState(localStorage.getItem("pc_branch") || "");

  const loadBranches = useCallback(async (u) => {
    const { data } = await api.get("/branches");
    setBranches(data);
    const saved = localStorage.getItem("pc_branch") || "";
    if (!u.all_branches && data.length && !data.find((b) => b.id === saved)) setBranch(data[0].id);
  }, []);

  const check = useCallback(async () => {
    if (window.location.hash?.includes("session_id=") || !localStorage.getItem("pc_token")) {
      setUser(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      loadBranches(data);
    } catch {
      setUser(false);
    }
  }, [loadBranches]);

  useEffect(() => {
    check();
  }, [check]);

  const setBranch = (id) => {
    localStorage.setItem("pc_branch", id);
    setBranchState(id);
  };

  const signIn = (data) => {
    localStorage.setItem("pc_token", data.token);
    setUser(data.user);
    loadBranches(data.user);
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {}
    localStorage.removeItem("pc_token");
    localStorage.removeItem("pc_branch");
    setUser(false);
  };

  const can = (...perms) => !!user && perms.some((p) => user.permissions?.includes(p));
  const branchName = (id) => branches.find((b) => b.id === id)?.code || "—";

  return (
    <Ctx.Provider value={{ user, signIn, logout, can, branches, branch, setBranch, branchName, reloadBranches: () => loadBranches(user) }}>
      {children}
    </Ctx.Provider>
  );
}

export const useAuth = () => useContext(Ctx);
